import React from "react";
import { Button, Col, Modal, Row, Typography } from "antd";
import { useSelector } from "react-redux";
import { useDraftBailiffForward } from "hook/draft/bailiff/useDraftBailiffForward";
import { draftBailiffOpenForwardSelector } from "store/bailiff/draft/bailiff/draft_bailiff.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogPageEstimate = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleForward, handleCancel } = useDraftBailiffForward();

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(draftBailiffOpenForwardSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={open}
      onCancel={() => handleCancel()}
      title="Bạn có chắc bạn muốn forward file này sang khách hàng ?"
      footer={null}
      centered
    >
      <Row gutter={[0, 10]}>
        <Col className="mt-5" xl={24} lg={24} md={24} xs={24}>
          <Typography.Paragraph className="border-[1px] border-dashed border-gray-300 bg-gray-100 p-[16px] text-red-600">
            Xin vui lòng xác nhận lần nữa bởi vì thao tác này sẽ không thể được
            phục hồi
          </Typography.Paragraph>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Button
            onClick={handleForward}
            loading={loading}
            type="primary"
            block
          >
            Xác Nhận
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogPageEstimate;
